// extracted by mini-css-extract-plugin
export default {"language":"styles_language__Zf4fL"};